import { render, staticRenderFns } from "./MainConfig.vue?vue&type=template&id=a4f8c29a&scoped=true"
import script from "./MainConfig.vue?vue&type=script&lang=js"
export * from "./MainConfig.vue?vue&type=script&lang=js"
import style0 from "./MainConfig.vue?vue&type=style&index=0&id=a4f8c29a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4f8c29a",
  null
  
)

export default component.exports